<template>
  <div class="tabs-wrapper">
    <el-tabs v-model="activeName">
      <!-- <el-tab-pane label="商品" name="commodity"></el-tab-pane> -->
      <el-tab-pane label="产品" name="product"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'current',
    event: 'change'
  },
  props: ['current', 'form'],
  data() {
    return {
      activeName: 'product'
    }
  },
  mounted() {
    this.addListener_refresh();
    this.init();
  },
  watch: {
    activeName(val) {
      this.$emit('change', val);
    }
  },
  methods: {
    addListener_refresh() {
      this.$bus.$off('tabsBarReload');
      this.$bus.$on('tabsBarReload', _=>{
        this.init();
      });
    },
    init() {
      // 默认选中第一个tab
      if(!this.current) {
        this.activeName = 'product';
        this.$emit('change', 'product');
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.tabs-wrapper
  background #ffffff
  padding 10px
  position relative
  padding-bottom 0px
  padding-top 0px

>>> .el-tabs__header
  margin-bottom 0
</style>
